import React from 'react';
import { useTranslation } from 'react-i18next';
import SingleDatePicker from 'components/DatePicker';
import PrevArrowIcon from 'assets/chevron-left';
import CalendarIcon from 'assets/calendar';
import NextArrowIcon from 'assets/chevron-right';
import { SrOnly } from 'components/common/styled/common-styled';
import { Moment } from 'moment';
import { PrevIconCalendar, NextIconCalendar, IconBack } from './styles';

interface SingleDatePickerFormWrapperProps {
  date: Moment | null;
  initialVisibleMonth: () => Moment;
  isDayHighlighted: (date: Date) => boolean;
  isMobile: boolean;
  isOutsideRange: (date: Date) => boolean;
  onChange: (date: Date) => void;
  onNextMonthClick: () => void;
  onPrevMonthClick: () => void;
  setCalendarLoading: (loading: boolean) => void;
}

const HostExperienceSingleDatePicker = ({
  date,
  initialVisibleMonth,
  isDayHighlighted,
  isMobile,
  isOutsideRange,
  onChange,
  onNextMonthClick,
  onPrevMonthClick,
  setCalendarLoading,
}: SingleDatePickerFormWrapperProps) => {
  const { t } = useTranslation();
  return (
    <SingleDatePicker
      numberOfMonths={1}
      date={date}
      onChange={onChange}
      isDayHighlighted={isDayHighlighted}
      displayFormat="MMM D"
      orientation={isMobile ? 'vertical' : 'horizontal'}
      transitionDuration={isMobile ? 0 : 300}
      verticalHeight={350}
      isOutsideRange={isOutsideRange}
      onPrevMonthClick={onPrevMonthClick}
      onNextMonthClick={onNextMonthClick}
      initialVisibleMonth={initialVisibleMonth}
      readOnly
      navPrev={
        <PrevIconCalendar
          tabIndex={0}
          onClick={() => setCalendarLoading(true)}
          role="button"
        >
          <PrevArrowIcon />
        </PrevIconCalendar>
      }
      navNext={
        <NextIconCalendar
          tabIndex={0}
          onClick={() => setCalendarLoading(true)}
          role="button"
        >
          <NextArrowIcon />
        </NextIconCalendar>
      }
      id="kouto_selectedSessionDateAvailabilityCalendarSelector"
      customInputIcon={
        <>
          <IconBack>
            <CalendarIcon role="presentation" />
          </IconBack>
          <SrOnly>{t('calendarIcon')}</SrOnly>
        </>
      }
      inputIconPosition="before"
    />
  );
};

export default HostExperienceSingleDatePicker;
